import { motion } from 'framer-motion'
import React from 'react';

interface IOverlayProps {
  children: React.JSX.Element
  close: (e: any) => void
  layout?: 'center' | 'scroll'
}

export default function Overlay({ children, close, layout = 'center' }: IOverlayProps) {
  const variants = {
    open: { backgroundColor: 'rgba(0,0,0,0.85)' },
    closed: { backgroundColor: 'rgba(0,0,0,0)' },
  }

  const isScrollLayout = layout === 'scroll';

  return (
    <motion.div
      className="header-overlay"
      onClick={close}
      variants={variants}
      initial={'closed'}
      animate={'open'}
      exit={'closed'}
      key="overlay"
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: 100,
        left: 0,
        top: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: isScrollLayout ? 'flex-start' : 'center',
        overflowY: isScrollLayout ? 'auto' : 'hidden',
        overflowX: 'hidden',
        padding: isScrollLayout ? '24px 12px' : '0',
      }}
    >
      {children}
    </motion.div>
  )
}
